import { render, staticRenderFns } from "./TableMatricsRow.vue?vue&type=template&id=1964c06d&"
import script from "./TableMatricsRow.vue?vue&type=script&lang=js&"
export * from "./TableMatricsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports